import { IMatch } from "apis";

export const buildMatchTitle = (match: IMatch) => {
  const homeTeam = match.homeFullTeam;
  const awayTeam = match.awayFullTeam;
  return `${homeTeam ? homeTeam.name : "-"} vs ${
    awayTeam ? awayTeam.name : "-"
  } (${match.homeScore >= 0 ? match.homeScore : "-"} : ${
    match.awayScore >= 0 ? match.awayScore : "-"
  })
  `;
};

const INCOMPLETE_MATCH_COLOR = "#AAAAAA";
const WIN_MATCH_COLOR = "#2EAC2C";
const DRAW_MATCH_COLOR = "#D6B72B";
const LOSE_MATCH_COLOR = "#C3101C";

export const getMatchEventColor = (match: IMatch) => {
  if (match.homeScore < 0 || match.awayScore < 0) {
    return INCOMPLETE_MATCH_COLOR;
  }

  if (match.homeScore === match.awayScore) {
    return DRAW_MATCH_COLOR;
  }

  if (match.homeScore > match.awayScore) {
    return WIN_MATCH_COLOR;
  }

  return LOSE_MATCH_COLOR;
};
